
import CountrySelector from '../../components/www/CountrySelector.vue'
import { SiteEvent, Speaker, SiteEventTag } from '@/models/www/SiteEvent'
import { saveWwwImage } from '../../api/www.api'
import Calendar from 'primevue/calendar'
import Textarea from 'primevue/textarea'
import SelectButton from 'primevue/selectbutton'
import Dialog from 'primevue/dialog'
import MultiSelect from 'primevue/multiselect'
import { computed, defineComponent, onMounted, PropType, reactive, ref } from 'vue'
import { FilterMatchMode } from 'primevue/api'
import FileUpload from 'primevue/fileupload'
import { getCategories } from '@/api/product-categories.api'
import { ProductCategory } from '@/models/www/ProductCategory'

const emptySpeaker: (speaker: Speaker | Record<string, never>) => Speaker = (speaker: Speaker | Record<string, never>) => ({
  name: speaker.name || '',
  lastName: speaker.lastName || '',
  avatar: speaker.avatar || '',
  position: speaker.position || '',
  company: speaker.company || '',
  companyImage: speaker.companyImage || ''
})

export default defineComponent({
  name: 'EditEventDialog',
  components: { CountrySelector, SelectButton, Dialog, Calendar, MultiSelect, Textarea, FileUpload },
  emits: [
    'onCancel',
    'onSave', ''
  ],
  props: {
    event: {
      type: Object as PropType<SiteEvent>,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    }
  },
  setup (props, { emit }) {
    const editableEvent = reactive(props.event)
    const showSpeakersAdd = ref<boolean>(false)
    const editableSpeaker = ref<Speaker>(emptySpeaker({}))
    const tags = ref<Array<SiteEventTag>>([])

    const visible = computed({
      get () {
        return props.show
      },
      set () {
        emit('onCancel')
      }
    })

    const filters = ref({
      global: { value: null, matchMode: FilterMatchMode.CONTAINS }
    })

    const validData = computed(() => !!(editableEvent.title.trim()) && !!(editableEvent.description.trim()))

    const onSave = () => {
      emit('onSave', editableEvent)
    }

    const onEditSpeakers = () => {
      showSpeakersAdd.value = true
    }

    const addNewSpeaker = () => {
      editableSpeaker.value = emptySpeaker({})
      showSpeakersAdd.value = true
    }

    const closeEditDialog = () => {
      emit('onCancel')
    }

    const onSaveNewSpeaker = (speaker: Speaker) => {
      const speakerExists = editableEvent.speakers.find(s => s.lastName === speaker.lastName)

      if (!speakerExists) editableEvent.speakers.push(speaker)
      else editableEvent.speakers = editableEvent.speakers.map(sp => sp.lastName === speaker.lastName ? speaker : sp)

      editableSpeaker.value = emptySpeaker({})
      showSpeakersAdd.value = false
    }

    const onRemoveSpeaker = (speakerToRemove: Speaker) => {
      editableEvent.speakers = editableEvent.speakers.filter(speaker => speaker.lastName !== speakerToRemove.lastName)
    }

    const onEditSpeaker = (speaker: Speaker) => {
      editableSpeaker.value = emptySpeaker(speaker)
      showSpeakersAdd.value = true
    }

    const onCancelNewSpeaker = () => {
      showSpeakersAdd.value = false
    }

    /**
     * Executes when file has uploaded satisfactorily
     * @param { XMLHttpRequest } xhr XMLHttpRequest
     * @param { any } files
     * @returns Void
     */
    const onUploaded = (xhr: XMLHttpRequest, files: any) => {
      console.log({ xhr, files })
    }

    /**
     * Executes to upload image.
     * @param { File[] } files
     * @returns Void
     */
    const onUpload = async (event: any) => {
      console.log({ files: event.files, file: event.files[0] })
      const response = await saveWwwImage(event.files[0])
      console.log(response)
      console.log(response.url)
      editableSpeaker.value.avatar = response.url
    }

    const states = [
      {
        name: 'Borrador',
        code: 'Draft'
      },
      {
        name: 'Publicado',
        code: 'Published'
      },
      {
        name: 'Eliminado',
        code: 'Deleted'
      }
    ]

    const types = [
      {
        name: 'Webinars',
        code: 'Webinars'
      },
      {
        name: 'Entrevistas',
        code: 'Entrevistas'
      },
      {
        name: 'CharlasInformativas',
        code: 'CharlasInformativas'
      }
      // {
      //   name: 'ClasesGratuitas',
      //   code: 'ClasesGratuitas'
      // }
    ]

    const updateDeps = async () => {
      const categories: Array<ProductCategory> = await getCategories()
      tags.value.push(...categories.map(({ key, name }) => ({ key, name }), { name: 'Charlas Informativas', key: 'Charlas Informativas' }))
    }

    const onlineOptions = [
      {
        name: 'Si',
        code: true
      },
      {
        name: 'No',
        code: false
      }
    ]

    onMounted(async () => {
      await updateDeps()
    })

    return {
      editableEvent,
      onSaveNewSpeaker,
      onRemoveSpeaker,
      onEditSpeaker,
      onCancelNewSpeaker,
      showSpeakersAdd,
      editableSpeaker,
      addNewSpeaker,
      closeEditDialog,
      onSave,
      onEditSpeakers,
      visible,
      validData,
      states,
      types,
      filters,
      tags,
      onlineOptions,
      onUploaded,
      onUpload
    }
  }
})
